


































































import Vue from 'vue';
import { Lang, StatsCardData } from '@/store/types';

export default Vue.extend({
  props: {
    data: {
      type: Object as () => StatsCardData,
      required: true,
    },
  },
  computed: {
    langITitle(): string {
      return '';
    },
  },
  methods: {

  },
});
